<mat-icon
    svgIcon="info"
    [matTooltipClass]="matTooltipClass"
    [matTooltip]="text | appTranslate"
    [matTooltipPosition]="tooltipPosition"
    #tooltip="matTooltip"
></mat-icon>
